import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette from "./PMGColorPalette";
import {PanelBody,Panel,RangeControl,SelectControl,TextControl,CheckboxControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck
} from '@wordpress/block-editor';

registerBlockType({
  "name":"template-scripts/section-holder",
  "title":"Section Holder",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    backgroundColor:{type:'string'},
    backgroundColorKey:{type:'string'},
    patternBG:{type:'boolean',default:false},
    patternBGWide:{type:'boolean',default:false},
    noPadding:{type:'boolean',default:false},
    width:{type:'string',default:'default'},
    slug:{type:'string',default:''}
  }
},{
  edit:function({attributes,setAttributes}){
    var patternCSS = `url(${VARIABLES.templateurl}/images/hero-pattern.png)`;
    if(attributes.backgroundColorKey == "Brown" || attributes.backgroundColorKey == "Black" || attributes.backgroundColorKey == "Orange"){
      patternCSS = `url(${VARIABLES.templateurl}/images/hero-pattern-light.webp)`;
    }
    const backgroundPatternImage = attributes.patternBG ? patternCSS : `none`;
    return (<>
      <InspectorControls>
        <Panel>

          <PanelBody title="Section Slug">
            * For Paralax Scrolling
            <TextControl
              value={attributes.slug}
              onChange={(v)=>setAttributes({slug:v})}
            />
          </PanelBody>
          <PanelBody title="Section Width">
            <SelectControl
              options={[
                {value:'extraNarrow',label:'Extra Narrow'},
                {value:'narrower',label:'Narrower'},
                {value:'narrow',label:'Narrow'},
                {value:'default',label:'Default'},
                {value:'wide',label:'Wide'},
                {value:'full',label:'Screen Width'},
              ]}
              onChange={(v)=>setAttributes({width:v})}
              value={attributes.width}
            />
          </PanelBody>
        </Panel>    
        <Panel>
          <PanelBody title="Background">
            <PMGColorPalette
                value={attributes.backgroundColor}
                onChange={(v,ck)=>{ 
                  setAttributes({backgroundColor:v,backgroundColorKey:ck});
                 }}
            />
            <CheckboxControl
              label="No Padding"
              checked={attributes.noPadding}
              onChange={(v)=>setAttributes({noPadding:v})}

            />
            <CheckboxControl
                label="Show Pattern Background"
                checked={attributes.patternBG}
                onChange={(v)=>setAttributes({patternBG:v})}

              />
              {attributes.patternBG ? (<CheckboxControl
                label="Stretch Pattern Background to Full Screen Width"
                checked={attributes.patternBGWide}
                onChange={(v)=>setAttributes({patternBGWide:v})}
              />) : (<></>)}
          </PanelBody>
          
        </Panel>
      </InspectorControls>
      <BlockControls></BlockControls>
      <div {...useBlockProps()}>
        <div className={`sectionHolder ${attributes.noPadding ? `noPadding` : ``} ${attributes.patternBG ? `pattern` : ``} ${attributes.backgroundColorKey}`} style={{backgroundColor:attributes.backgroundColor,backgroundImage:attributes.patternBGWide ? backgroundPatternImage : ``}}>
          <div className={`container ${attributes.width}`} style={{backgroundImage:attributes.patternBGWide ? `` : backgroundPatternImage}}>
            <div className="holderInnerBlocks">
              <InnerBlocks/>
            </div>
          </div>
        </div>
      </div>
    </>);
  },
  save:function({attributes}){
    var patternCSS = `url(${VARIABLES.templateurl}/images/hero-pattern.png)`;
    if(attributes.backgroundColorKey == "Brown" || attributes.backgroundColorKey == "Black" || attributes.backgroundColorKey == "Orange"){
      patternCSS = `url(${VARIABLES.templateurl}/images/hero-pattern-light.webp)`;
    }
    const backgroundPatternImage = attributes.patternBG ? patternCSS : `none`;
    return (<div className={`sectionHolder ${attributes.noPadding ? `noPadding` : ``}  ${attributes.patternBG ? `pattern` : ``} ${attributes.backgroundColorKey}`} style={{backgroundColor:attributes.backgroundColor,backgroundImage:attributes.patternBGWide ? backgroundPatternImage : ``}}>
      <a name={`${attributes.slug}`}></a>
      <div data-parallax={attributes.slug} className={`container ${attributes.width}`} style={{backgroundImage:attributes.patternBGWide ? `` : backgroundPatternImage}}>
        <div className="holderInnerBlocks">
          <InnerBlocks.Content/>
        </div> 
      </div>
    </div>);
  }
});
